import { render, staticRenderFns } from "./increase.vue?vue&type=template&id=2fe02dc2&scoped=true"
import script from "./increase.vue?vue&type=script&lang=js"
export * from "./increase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe02dc2",
  null
  
)

export default component.exports